<template>
  <div >
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-container fluid>

      <b-row>
        <b-col class="subtitulos">
          Generación de reporte de Ptis presentados
        </b-col>
      </b-row>
      <div class="mt-2 col-md-12"></div>
            <validation-observer ref="observer" v-slot="{ handleSubmit }">
              <b-form @submit.stop.prevent="handleSubmit(buscar)">
                <b-row>
                  <b-col>
                    <b-row>
                      <b-col cols="4">
                        <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
                          <label>Fecha inicio:<validacion/></label>
                          <b-input-group size="sm" class="mb-2">
                            <b-form-datepicker placeholder="Fecha inicio"
                                               :max="new Date()"
                                               @input="fechaMaxima($event)"
                            ></b-form-datepicker>
                          </b-input-group>
                          <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                        </validation-provider>
                      </b-col>

                      <b-col cols="4">
                        <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
                          <label>Fecha fin:<validacion/></label>
                          <b-input-group size="sm" class="mb-2">
                            <b-form-datepicker placeholder="Fecha fin"
                                               v-model="filtro.fechaFin"
                                               :max="filtro.fechaInicio.addDays(diasMaximoMes) > new Date() ? new Date(): filtro.fechaInicio.addDays(diasMaximoMes)"
                                               :min="filtro.fechaInicio"
                            ></b-form-datepicker>
                          </b-input-group>
                          <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                        </validation-provider>
                      </b-col>
                <b-col cols="4">
                <b-form-group size="sm" class="mb-2">
                  <label>Tipo Reporte:<validacion/></label>
                 <b-form-select v-model="filtro.tipoBusqueda" :options="options" size="sm"></b-form-select>
                 </b-form-group>
                  </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
      <b-row>
        <b-col>
          <b-row align-v="center" align-h="end">

            <b-col>
              <download-excel
                  v-if="datosTabla.length > 0 && $localStorageService.can('BT_Excel_presu_cdx_m2') && filtro.tipoBusqueda === '0'"
                  :data="datosTabla"
                  class="btn btn-primary"
                  :fields="fieldsExcel"

                  worksheet="My Worksheet"
                  name="reportePtisPresentados.xls"
              >
                Generar Excel
              </download-excel>
              <download-excel
                  v-if="datosTabla.length > 0 && $localStorageService.can('BT_Excel_presu_cdx_m2') && filtro.tipoBusqueda === '1'"
                  :data="datosTabla"
                  class="btn btn-primary"
                  :fields="fieldsExcelDetalle"

                  worksheet="My Worksheet"
                  name="reportePtisPresentadosDetalle.xls"
              >
                Generar Excel
              </download-excel>
            </b-col>


            <b-col cols="2" align="right">
              <b-button v-b-tooltip.hover title="Generar reporte" variant="outline-success"
                        @click="generar()" :disabled="loader">Generar
              </b-button>
            </b-col>

          </b-row>
        </b-col>
      </b-row>
      <div class="mt-2 col-md-12"></div>

      <b-row>
        <b-col cols="12">
          <b-table
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              responsive
              class="parrafos">
             <template v-slot:cell(monto)="row">
              {{ row.item.monto | monedaEntero }}
            </template>
            <template v-slot:cell(montoTratamiento)="row">
              {{ row.item.montoTratamiento | monedaEntero }}
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla!==undefined && datosTabla.length === 0" variant="warning" show>No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tabla"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>

    </b-container>
  </div>
</template>

<script>

import {required} from "vuelidate/lib/validators";

export default {
  name: "reportePtiPresentados",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    diasMaximoMes: null,
    datosTabla: [],
    fields: [],
    paginaActual: 1,
    loader: false,
    filtro: {
      fechaInicio: null,
      fechaFin: null,
      tipoBusqueda: '0'
    },
    fieldsExcel: {
      "Tipo solicitud": "descripcionpti",
      "Id Paciente":"idPaciente",
      "Id Pti": "idPti",
      "Nombre":"nombrePaciente",
      "Clinica":"fase",
      "Opción presentada":"opcionAceptada",
      "Fase":"embajador",
      "Monto ($)":"monto",
      "Tipo paciente":"fechaPresupuesto",
      "Fecha presentación":"tipoPaciente",
      "Estatus PTI":"descripcion",
      "Veces Presentado":"veces"

    },
    fieldsExcelDetalle: {
      "Tipo solicitud": "descripcionpti",
      "Id Paciente":"idPaciente",
      "Id Pti": "idPti",
      "Nombre":"nombrePaciente",
      "Clinica":"fase",
      "Opción presentada":"opcionAceptada",
      "Fase":"embajador",
      "Monto":"monto",
      "Tipo paciente":"fechaPresupuesto",
      "Fecha presentación":"tipoPaciente",
      "Estatus PTI":"descripcion",
      "Veces Presentado":"veces",
      "Tratamiento":"tratamiento",
      "Monto Tratamiento ($)":"montoTratamiento"

    },
        options: [
          { value: '1', text: 'PTI COBRADO CON TXS'},
          { value: '0', text: 'PTI COBRADO'}
        ]
  }),
  validations: {
    filtro: {
      fechaInicio: {required},
      fechaFin: {required},
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    fechaMaxima(event){
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.filtro.fechaInicio = new Date(event);
      this.filtro.fechaFin = null;

    },
    dateDisabled(ymd, date) {
        const weekday = date.getDay();
        return weekday >= 1 && weekday <= 5;
     /* const weekday = date.getDay()
      const day = date.getDate()
      return weekday === 0 || weekday === 6 || day === 13*/
    },
    generar() {
      this.loader = true;
      this.datosTabla = [];
      this.fields = [];
      this.$http.post(this.$api + 'reportes/obtenerReportePtisPresentados', this.filtro).then(respuesta => {
        if (respuesta.data.data.reportePtisDTOList) {
          this.fields.push({key: "descripcionpti", label: "Tipo solicitud", sortable: true});
          this.fields.push({key: "idPaciente", label: "Id Paciente", sortable: true});
          this.fields.push({key: "idPti", label: "Id Pti", sortable: true});
          this.fields.push({key: "nombrePaciente", label: "Nombre", sortable: true});
          this.fields.push({key: "fase", label: "Clinica", sortable: true});
          this.fields.push({key: "opcionAceptada", label: "Opción presentada", sortable: true});
          this.fields.push({key: "embajador", label: "Fase", sortable: true});
          this.fields.push({key: "monto", label: "Monto", sortable: true});
          this.fields.push({key: "fechaPresupuesto", label: "Tipo paciente", sortable: true});
          this.fields.push({key: "tipoPaciente", label: "Fecha presentación", sortable: true});
          this.fields.push({key: "descripcion", label: "Estatus PTI", sortable: true});
          this.fields.push({key: "veces", label: "Veces presentado", sortable: true});
          if(this.filtro.tipoBusqueda === "1"){
            this.fields.push({key: "tratamiento", label: "Tratamiento", sortable: true});
            this.fields.push({key: "montoTratamiento", label: "Monto Tratamiento ($)", sortable: true});
          }


          this.datosTabla = respuesta.data.data.reportePtisDTOList
        }
      }).finally(() => {
        this.loader = false;
        this.paginaActual = 1;
      })
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.filtro[name];
      return $dirty ? !$error : null;
    },
  }
}
</script>

<style scoped>

</style>
